<template>
    <div class="aspect-square relative mx-auto mt-14 mb-23 w-[14.5rem] max-w-full h-[14.5rem] md:w-[26rem] md:h-[26rem]">
        <RouterLink :to="productUrl"
                    :title="productTitle">
            <ImageWrap v-if="product.image"
                       format="webp"
                       :image="product.image"
                       :width="300"
                       :name="productTitle"
                       styles="object-contain mx-auto w-full h-full"/>
        </RouterLink>
        <div class="absolute right-0 bottom-0">
            <ProductSplash v-if="product.splashText"
                           :key="product.sku+'splash'"
                           :product="product"
                           :sku="product?.sku"/>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { CatalogProductTileViewObject } from '@/api/content/models/catalog-product-tile-view-object';
import ImageWrap from '@/project/shared/ImageWrap.vue';
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { productService } from './product.service';
import ProductSplash from './ProductSplash.vue';

type Props = {
    product: CatalogProductTileViewObject;
    index: number;
    contentBlockIndex: number;
}

type ProductTileTitleSource = CatalogProductTileViewObject & {
    fullname?: string | null;
    fullName?: string | null;
    name?: string | null;
    DisplayName?: string | null;
};

function getProductTitle(product: ProductTileTitleSource): string {
    return product.displayName || product.fullname || product.fullName || product.name || product.DisplayName || '';
}

const props = defineProps<Props>();

const productUrl = productService.getProductRedirectUrlByProduct(props.product);
const productTitle = computed(() => getProductTitle(props.product as ProductTileTitleSource));

</script>
